import Hls from 'hls.js';
import { onUnmounted } from 'vue';
export default {
  data: function data() {
    return {
      pageConfig: {
        editPageName: '摄像头播放',
        detailFunName: 'videoDetail'
      }
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    idName: {
      type: String,
      default: ''
    },
    playUrl: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    this.url = this.playUrl;
    if (this.playUrl) {
      this.options();
    } else {
      this.query();
    }
  },
  onUnmounted: function onUnmounted() {
    this.video.pause();
    this.video.src = '';
    this.video.load();
  },
  destroyed: function destroyed() {
    this.video.pause();
    this.video.src = '';
    this.video.load();
  },
  methods: {
    query: function query() {
      var _this = this;
      this.$api['videoPlayUrl'](this.id).then(function (res) {
        if (res.data) {
          _this.url = res.data;
          _this.options();
        }
      });
    },
    options: function options() {
      this.video = document.getElementById("valveVideogj".concat(this.idName || this.id));
      if (Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(this.url);
        hls.attachMedia(this.video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          this.video.play();
        });
      } else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
        this.video.src = this.url;
        this.video.addEventListener('loadedmetadata', function () {
          this.video.play();
        });
      }
    }
  }
};